import React from 'react';
import PropTypes from 'prop-types';

import filter from '../../assets/images/filtros.svg';
import './nav.scss';

const Nav = ({ openFilter, searchText, onSearchChange }) => {
  return (
    <nav className='nav'>
      <div className='nav_top-row'>
        <div className='nav_title'>RESULTADOS</div>
        <button
          type='button'
          className='nav_filter-button'
          onClick={() => {
            openFilter();
          }}
        >
          <img
            src={filter}
            alt='filter'
            className='nav_filter'
          />
        </button>
      </div>
      <div className='nav_search-row'>
        <input
          className='nav_search'
          type='text'
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder='Buscar equipo o participante'
        />
      </div>
    </nav>
  );
};

Nav.propTypes = {
  openFilter: PropTypes.func.isRequired,
  searchText: PropTypes.string,
  onSearchChange: PropTypes.func,
};

Nav.defaultProps = {
  searchText: '',
  onSearchChange: () => {},
};

export default Nav;
